import React from 'react';
import './TranscriptPanel.css';

const TranscriptPanel = ({ transcript, onClose }) => {
  const formatTime = (timestamp) => {
    return timestamp.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', second: '2-digit' });
  };

  const downloadTranscript = () => {
    if (transcript.length === 0) {
      alert('No transcript data to download');
      return;
    }

    const transcriptText = transcript.map(entry => 
      `[${formatTime(entry.timestamp)}] ${entry.speaker}: ${entry.text}`
    ).join('\n\n');

    const blob = new Blob([transcriptText], { type: 'text/plain' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `campaign-conversation-${new Date().toISOString().split('T')[0]}.txt`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  const clearTranscript = () => {
    if (window.confirm('Are you sure you want to clear the transcript? This action cannot be undone.')) {
      // For now, we'll just close the panel since we can't modify the ChatContext messages from here
      // In a real implementation, you'd want to add a clearTranscript function to ChatContext
      onClose();
    }
  };

  return (
    <div className="transcript-panel">
      <div className="transcript-header">
        <h3>📝 Campaign Conversation Transcript ({transcript.length} messages)</h3>
        <button className="close-btn" onClick={onClose} aria-label="Close transcript">×</button>
      </div>
      
      <div className="transcript-content">
        {transcript.length === 0 ? (
          <div className="no-transcript">
            <p>No transcript data available yet.</p>
            <p>Start speaking to see the transcript appear here in real-time.</p>
          </div>
        ) : (
          transcript.map((entry) => (
            <div key={entry.id} className={`transcript-entry ${entry.speaker === 'You' ? 'user' : 'alexander'}`}>
              <div className="entry-header">
                <span className="speaker">{entry.speaker}</span>
                <span className="timestamp">{formatTime(entry.timestamp)}</span>
              </div>
              <div className="entry-text">{entry.text}</div>
            </div>
          ))
        )}
      </div>
      
      <div className="transcript-footer">
        <button 
          className="download-btn" 
          onClick={downloadTranscript}
          disabled={transcript.length === 0}
        >
          📥 Download Transcript
        </button>
        <button 
          className="clear-btn" 
          onClick={clearTranscript}
          disabled={transcript.length === 0}
        >
          🗑️ Clear
        </button>
      </div>
    </div>
  );
};

export default TranscriptPanel;